export default "__VITE_ASSET__BclaF5je__"